export default __webpack_public_path__ + "c266e44cc9ab16fc8a4bbca23836d615.png";